import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgAsyncGuiRef } from '@sg/ui-kit/async-gui';
import { SgAsyncGuiToasterPlugin } from './plugin';

@NgModule({
  imports: [CommonModule],
})
export class SgAsyncGuiToasterPluginModule {
  static readonly PLUGIN = SgAsyncGuiToasterPlugin;
}
